export default __webpack_public_path__ + "static/layout_cloud_middleRight-709cee22884eec968c3d700a029d7cb4.png";